import { Flex, Group, Image, Menu, MenuDropdown, MenuItem, Stack, Text, UnstyledButton, VisuallyHidden } from '@mantine/core'
import { IconAt, IconMapPin, IconPhone } from '@tabler/icons-react'
import { useMemo } from 'react'
import { Link, useParams } from '@tanstack/react-router'
import { facilities, useEssentialStore } from '@/layouts/esssential.store'
import { TwContainer } from '@/lib/components/TwContainer'

export const Footer = () => {
	const { location } = useParams({ strict: false })
	const prefix = useMemo(() => (location ? `/${location}` : ''), [location])
	const essentialStore = useEssentialStore()
	return (
		<section className={'bg-secondary'}>
			<Flex className="w-full !m-0 bg-accent  justify-center " wrap={'wrap'}>
				<TwContainer md className="md:py-20 py-16 px-8 flex-col justify-center items-center gap-8 h-fit">
					<Stack justify={'center'} align={'center'}>
						<Image src={essentialStore.logo} h={90} mah={90} fit={'contain'} alt={'Wellview Care'} />
						<UnstyledButton c={'gray.7'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 866 502 5545'}>
							<IconPhone /> 866-502-5545
						</UnstyledButton>
					</Stack>
					<Group gap={'xl'} justify={'space-around'} className={'w-full'}>
						<Stack gap={'sm'}>
							<Text variant={'gray'} ta={'left'}>
								<IconMapPin /> 906 W Sunrise Blvd Suite A,
								<br /> Fort Lauderdale, FL 33311
							</Text>
							<UnstyledButton c={'gray.7'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 844-650-2626'}>
								<IconPhone /> 844-650-2626
							</UnstyledButton>
							<UnstyledButton className={'flex items-center gap-2'} c={'gray.7'} component={'a'} href={'mailto:office@wellviewcare.org'}>
								<IconAt /> office@wellviewcare.org
							</UnstyledButton>
						</Stack>
						<Stack gap={'sm'}>
							<Text variant={'gray'} ta={'left'}>
								<IconMapPin /> 2708 S US Hwy 1,
								<br /> Fort Pierce, FL 34982
							</Text>
							<UnstyledButton c={'gray.7'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 772-310-4250'}>
								<IconPhone /> 772-310-4250
							</UnstyledButton>
							<UnstyledButton className={'flex items-center gap-2'} c={'gray.7'} component={'a'} href={'mailto:office.fp@wellviewcare.org'}>
								<IconAt /> office.fp@wellviewcare.org
							</UnstyledButton>
						</Stack>
						<Stack gap={'sm'}>
							<Text variant={'gray'} ta={'left'}>
								<IconMapPin /> 1128 N Laura St,
								<br /> Jacksonville, FL 32206, USA
							</Text>
							<UnstyledButton c={'gray.7'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 904-867-7968'}>
								<IconPhone /> 904-867-7968
							</UnstyledButton>
							<UnstyledButton className={'flex items-center gap-2'} c={'gray.7'} component={'a'} href={'mailto:office.jax@wellviewcare.org'}>
								<IconAt /> office.jax@wellviewcare.org
							</UnstyledButton>
						</Stack>
						<Stack gap={'sm'}>
							<Text variant={'gray'} ta={'left'}>
								<IconMapPin /> 3514 Broadway, <br />
								Riviera Beach, FL 33403
							</Text>
							<UnstyledButton c={'gray.7'} component={'a'} className={'flex items-center gap-2'} href={'tel:+1 561-821-4345'}>
								<IconPhone /> 561-821-4345
							</UnstyledButton>
							<UnstyledButton
								className={'flex items-center gap-2'}
								c={'gray.7'}
								mx={'auto'}
								component={'a'}
								href={'mailto:office.rv@wellviewcare.org'}
							>
								<IconAt /> office.rv@wellviewcare.org
							</UnstyledButton>
						</Stack>
					</Group>
				</TwContainer>
				<Flex className={'bg-primary w-full'}>
					<TwContainer className={'px-8 py-4 justify-center gap-6'} column>
						<Group className="text-white md:gap-8 mx-auto">
							<Menu position={'top'} withArrow>
								<Menu.Target>
									<UnstyledButton className="no-underline text-white">Services</UnstyledButton>
								</Menu.Target>
								<MenuDropdown>
									<MenuItem component={Link} to={`${prefix}/services/hiv`}>
										Human Immunodeficiency Virus (HIV)
									</MenuItem>
									<MenuItem component={Link} to={`${prefix}/services/hep-c`}>
										Hepatitis C (HEP-C)
									</MenuItem>
									<MenuItem component={Link} to={`${prefix}/services/prep`}>
										Pre-exposure Prophylaxis (PrEP)
									</MenuItem>
									<MenuItem component={Link} to={`${prefix}/services/pep`}>
										Post-exposure prophylaxis (PEP)
									</MenuItem>
									<MenuItem component={Link} to={`${prefix}/services/sti`}>
										Sexually transmitted infections (STIs)
									</MenuItem>
								</MenuDropdown>
							</Menu>
							|
							<Link className="no-underline text-white" to={'/appointment'}>
								Book an Appointment
							</Link>
							|
							<Menu position={'top'} withArrow>
								<Menu.Target>
									<UnstyledButton className="no-underline text-white">Locations</UnstyledButton>
								</Menu.Target>
								<MenuDropdown>
									<MenuItem component={Link} to={'/Fort-Lauderdale'}>
										Fort Lauderdale
									</MenuItem>
									<MenuItem component={Link} to={'/Riviera-Beach'}>
										Riviera Beach
									</MenuItem>
								</MenuDropdown>
							</Menu>
							|
							<Link className="no-underline text-white" to="/about">
								About
							</Link>
							|
							<Link className="no-underline text-white" to={'/gallery'}>
								Gallery
							</Link>
							|
							<Link className="no-underline text-white" to={'/blog'}>
								Blog
							</Link>
							|
							<Link className="no-underline text-white" to="/contact">
								Contact Us
							</Link>
							|
							<Link className="no-underline text-white" to={'/faq'}>
								FAQ
							</Link>
							|
							<Link className="no-underline text-white" to={'/donate'}>
								Donate
							</Link>
						</Group>
						<Text className="text-center text-white">
							© {new Date().getFullYear()}&nbsp;
							{essentialStore.name} All Rights Reserved
						</Text>
					</TwContainer>
				</Flex>
			</Flex>
			<VisuallyHidden>
				{['', ...facilities].map((facility) => (
					<Flex key={facility}>
						<Link to={'/services/hep-c'} params={{ location: facility.replace(' ', '-') }}>
							Hepatitis C (HEP-C)
						</Link>
						<Link to={'/$location/services/hiv'} params={{ location: facility.replace(' ', '-') }}>
							Human Immunodeficiency Virus (HIV)
						</Link>
						<Link to={'/services/pep'} params={{ location: facility.replace(' ', '-') }}>
							Post-exposure prophylaxis (PEP)
						</Link>
						<Link to={'/services/prep'} params={{ location: facility.replace(' ', '-') }}>
							Pre-exposure Prophylaxis (PrEP)
						</Link>
						<Link to={'/services/sti'} params={{ location: facility.replace(' ', '-') }}>
							Sexually transmitted infections (STIs)
						</Link>
						<Link to={'/$location/gallery'} params={{ location: facility.replace(' ', '-') }}>
							{facility} Gallery
						</Link>
						<Link to={'/$location'} params={{ location: facility.replace(' ', '-') }}>
							{facility || 'Home'}
						</Link>
					</Flex>
				))}
			</VisuallyHidden>
		</section>
	)
}
